import type { PortfolioAnalyticsPropertyResponseDto } from '@zg-rentals/ts-customer-analytics-client';

export const getAllAdSpendMapping = (properties: Array<PortfolioAnalyticsPropertyResponseDto>) => {
  const allAdSpendMapping = new Map<number, number>();
  const regionIdKeys: Array<keyof (typeof properties)[number]['propertyDetails']> = [
    'stateRegionId',
    'metroStatRegionId',
    'cityRegionId',
    'zipRegionId',
  ];

  properties.forEach((property) => {
    for (const regionIdKey of regionIdKeys) {
      const regionId = Number(property.propertyDetails[regionIdKey]);
      if (isNaN(regionId)) continue;

      if (regionId && !allAdSpendMapping.has(regionId)) {
        const propertiesFromRegion = properties.filter((p) => Number(p.propertyDetails[regionIdKey]) === regionId);
        const adSpendForRegion = propertiesFromRegion.reduce((acc, prop) => {
          return acc + (prop.aggregateStats.totalCost || 0);
        }, 0);
        allAdSpendMapping.set(regionId, adSpendForRegion);
      }
    }
  });

  return allAdSpendMapping;
};
